import React from "react";
import { NavHashLink } from "react-router-hash-link";

const Navbar = ({ lenguaje }) => {
  return (
    <nav>
      <ul>
        <NavHashLink smooth to="#home">
          <li> {lenguaje == "eng" ? "Home" : "Inicio"}</li>
        </NavHashLink>

        <NavHashLink smooth to="#aboutme">
          <li>{lenguaje == "eng" ? "About Me" : "Acerca de mí"} </li>
        </NavHashLink>

        <NavHashLink smooth to="#experience">
          <li>{lenguaje == "eng" ? "Experience" : "Experiencia"} </li>
        </NavHashLink>

        <NavHashLink smooth to="#projects">
          <li> {lenguaje == "eng" ? "Projects" : "Proyectos"} </li>
        </NavHashLink>

        <NavHashLink smooth to="#contactme">
          <li>{lenguaje == "eng" ? "Contact Me" : "Contacto"} </li>
        </NavHashLink>
      </ul>
    </nav>
  );
};

export default Navbar;
